import React from 'react';
import { captureException } from '../lib/errorReporter';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    captureException(error, { componentStack: info.componentStack });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="h-screen flex items-center justify-center p-8 bg-canvas-light dark:bg-canvas-dark">
          <div className="max-w-md text-center">
            <h1 className="text-xl font-semibold text-red-500 mb-2">Что-то сломалось</h1>
            <p className="text-sm text-ink-muted_l dark:text-ink-muted_d mb-4">
              Ошибка автоматически отправлена в систему отладки. Можно перезагрузить страницу.
            </p>
            <details className="text-xs text-left bg-surface-light dark:bg-surface-dark p-3 rounded border border-line-light dark:border-line-dark">
              <summary className="cursor-pointer font-medium">Подробности</summary>
              <pre className="mt-2 whitespace-pre-wrap break-all">{this.state.error.message}</pre>
            </details>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 text-sm rounded bg-accent text-white"
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
